import { Component, ElementRef, HostListener, input, signal, viewChild, WritableSignal } from '@angular/core';
import { FormControl, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { Router } from '@angular/router';
import { debounceTime, distinctUntilChanged, filter, switchMap, tap } from 'rxjs';
import { ProductSuggesstion } from 'src/app/interfaces/product';
import { ProductService } from 'src/app/services/Customer/Product/product.service';

@Component({
  selector: 'search-suggest',
  imports: [
    FormsModule,
    ReactiveFormsModule,
],
  templateUrl: './search-suggest.component.html',
  styleUrl: './search-suggest.component.scss'
})
export class SearchSuggestComponent {
  //DATA
  productSuggestions: WritableSignal<ProductSuggesstion[]> = signal([]);
  query: FormControl = new FormControl('');
  content = viewChild.required<ElementRef>('content');
  category = input<string>();

  //UI
  loading: WritableSignal<boolean> = signal(false);
  show: boolean = false;

  constructor(private router: Router,
              private productApi: ProductService
  ) {}

ngOnInit() {
  this.query.valueChanges.pipe(
    tap(() => { this.loading.set(true); this.show = true; }),
    debounceTime(500),
    distinctUntilChanged(),
    filter(query => query),
    switchMap(query => {
      return this.productApi.suggest(query.trim(), this.category());
    })
  ).subscribe({
    next: (val) => {
      this.productSuggestions.set(val.suggestions);
      this.loading.set(false)
    },
  });
}


  navigate(path: string) {
    window.location.href = `/browse/${path}`;
  }

  search(){
     const query = this.query.value.trim();
     if(!query){
       return;
     }
     this.query.setValue('');
     this.router.navigate(['/browse'],{queryParams: { q: query }});
  }

  @HostListener('document:mousedown', ['$event'])
  onClickAway(event: MouseEvent) {
    if (!this.content().nativeElement.contains(event.target)) {
     this.show = false;
    }
  }
}
